import { BehaviorSubject } from 'rxjs';
import { Service } from '../../../symphony';

@Service()
export class SlLoginLoadingService {
	public loading$ = new BehaviorSubject<boolean>(false);
}
